import { z } from 'zod';
import { conflictFindingSchema } from './visit.js';
/**
 * Caregiver matching for a visit (§14.4, slice-03 §5, exit criterion 6).
 *
 * Three lists, because they lead to three different next actions:
 *  - `ranked` — passed every caregiver rule; book one.
 *  - `excluded` — a rule refused them, or they are too far; choose someone else.
 *  - `unrankable` — nothing refused them but something could not be decided;
 *    fix their record, and they will rank.
 *
 * `visitBlocks` are refusals no choice of caregiver changes — the client is
 * already booked, the authorization is out of units — and are stated once.
 */
export const MAX_TRAVEL_MINUTES_DEFAULT = 60;
export const matchQuerySchema = z.object({
    /** Stage one's travel limit: §14.4 "within max_travel_minutes". */
    maxTravelMinutes: z.coerce.number().int().min(5).max(240).optional(),
});
const reasonSchema = z.object({ code: z.string(), message: z.string() });
export const matchSignalSchema = z.enum([
    'CONTINUITY',
    'PREFERRED',
    'TRAVEL',
    'OVERTIME',
    'LANGUAGE',
    'SOFT_PREFERENCES',
    'RELIABILITY',
    'HOURS_TARGET',
]);
export const matchResultSchema = z.object({
    visitId: z.string().uuid(),
    maxTravelMinutes: z.number().int(),
    /** The weights the scores were computed with, shown beside them. */
    weights: z.record(matchSignalSchema, z.number()),
    visitBlocks: z.array(reasonSchema),
    ranked: z.array(z.object({
        caregiverId: z.string().uuid(),
        name: z.string(),
        /** 0–100, over the signals that were measured. */
        score: z.number().int(),
        /** "worked with Ada Okafor 14 times · 6 min away · 12 h under OT" */
        explanation: z.string(),
        signals: z.array(z.object({
            signal: matchSignalSchema,
            weight: z.number(),
            /** 0–1. Null: unmeasured, left out of the score. */
            value: z.number().nullable(),
            text: z.string(),
        })),
        warnings: z.array(conflictFindingSchema),
    })),
    excluded: z.array(z.object({ caregiverId: z.string().uuid(), name: z.string(), reasons: z.array(reasonSchema) })),
    unrankable: z.array(z.object({ caregiverId: z.string().uuid(), name: z.string(), unknowns: z.array(reasonSchema) })),
});
//# sourceMappingURL=matching.js.map